export default "__VITE_ASSET__CtUUIKE8__"